module.exports = __webpack_public_path__ + "assets/img/filtrate-icon-2.51b259dd.png";